
import Button from '../../../components/base/Button';

export default function JoinHeroSection() {
  const handleLearnMore = () => {
    const advantagesSection = document.getElementById('advantages-section');
    if (advantagesSection) {
      advantagesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleStartSelling = () => {
    const ecommerceSection = document.getElementById('ecommerce-partners-section');
    if (ecommerceSection) {
      ecommerceSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(102, 51, 51, 0.7), rgba(102, 51, 51, 0.5)), url('https://public.readdy.ai/ai/img_res/e1692c51b9ae26a7e4ea0723ea885861.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* 左侧内容 */}
          <div className="text-white text-center lg:text-left">
            <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
              携手共赢
              <span className="block text-[#cc9966] mt-1 sm:mt-2">共创茶业未来</span>
            </h1>
            <p className="text-sm sm:text-lg lg:text-xl mb-6 sm:mb-8 text-orange-100 leading-relaxed px-2 sm:px-0">
              顺年陈茶业诚邀全国各地优秀合作伙伴，共同开拓高端茶叶市场，分享品牌成功红利
            </p>
            
            {/* 核心优势 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 mb-6 sm:mb-8 max-w-md sm:max-w-none mx-auto lg:mx-0">
              <div className="flex items-center justify-center lg:justify-start space-x-3">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <span className="text-xs sm:text-lg">线上验证爆品</span>
              </div>
              <div className="flex items-center justify-center lg:justify-start space-x-3">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <span className="text-xs sm:text-lg">高转化率保障</span>
              </div>
              <div className="flex items-center justify-center lg:justify-start space-x-3">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <span className="text-xs sm:text-lg">24小时发货</span>
              </div>
              <div className="flex items-center justify-center lg:justify-start space-x-3">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <span className="text-xs sm:text-lg">5.0满分体验</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                variant="secondary" 
                size="lg"
                className="rounded-lg text-sm sm:text-lg"
                onClick={handleStartSelling}
              >
                立即带货
              </Button>
              <button 
                onClick={handleLearnMore}
                className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-sm sm:text-lg hover:bg-white hover:text-[#663333] transition-colors duration-300 whitespace-nowrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#663333]"
              >
                了解详情
              </button>
            </div>
          </div>

          {/* 右侧统计数据 */}
          <div className="mt-8 lg:mt-0 lg:text-right">
            <div className="grid grid-cols-2 gap-4 sm:gap-6 max-w-md mx-auto lg:max-w-none">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center">
                <div className="text-xl sm:text-3xl font-bold text-[#cc9966] mb-1 sm:mb-2">500+</div>
                <div className="text-white text-xs sm:text-base">合作伙伴</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center">
                <div className="text-xl sm:text-3xl font-bold text-[#cc9966] mb-1 sm:mb-2">98%</div>
                <div className="text-white text-xs sm:text-base">续约率</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center">
                <div className="text-xl sm:text-3xl font-bold text-[#cc9966] mb-1 sm:mb-2">35%</div>
                <div className="text-white text-xs sm:text-base">平均佣金</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center">
                <div className="text-xl sm:text-3xl font-bold text-[#cc9966] mb-1 sm:mb-2">5.0</div>
                <div className="text-white text-xs sm:text-base">体验评分</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
